import { ExternalLink, Radio, Play } from "lucide-react";
import { useLivePlayer } from "@/context/LivePlayerContext";
import { useLang } from "@/context/LanguageContext";

const VIDEO_ID = "QB5BNdBFujE";
const WATCH = `https://youtu.be/${VIDEO_ID}`;

export function LiveStream() {
  const { open, openPlayer } = useLivePlayer();
  const { t } = useLang();
  return (
    <div data-testid="live-stream">
      {/* Emplacement (ancre) : le lecteur persistant vient se positionner par-dessus en grand */}
      <div data-live-anchor className="relative w-full overflow-hidden rounded-lg border border-[#222733] bg-black" style={{ paddingTop: "56.25%" }}>
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-gradient-to-b from-[#161208] to-black px-4 text-center">
          <span className="mb-3 flex items-center gap-1.5 rounded-full bg-red-500/15 px-2.5 py-1 text-[11px] font-bold uppercase tracking-wider text-red-300">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-red-500 opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-red-500" />
            </span>
            {t("common.live")}
          </span>
          <h4 className="font-heading text-sm font-bold text-white sm:text-base">{t("live.title")}</h4>
          {open ? (
            <p className="mt-1 text-xs text-slate-400" data-testid="live-playing-hint">{t("live.playing")}</p>
          ) : (
            <button onClick={openPlayer} data-testid="live-launch-btn"
              className="mt-3 flex items-center gap-2 rounded-lg bg-amber-500 px-5 py-2.5 text-sm font-bold text-black transition-opacity hover:opacity-90">
              <Play className="h-4 w-4 fill-black" /> {t("live.launch")}
            </button>
          )}
        </div>
      </div>
      <div className="mt-2 flex items-center justify-between text-[11px] text-slate-500">
        <span className="flex items-center gap-1.5"><Radio className="h-3 w-3 text-amber-400" /> {t("live.marketContinuous")}</span>
        <a href={WATCH} target="_blank" rel="noopener noreferrer"
          className="flex items-center gap-1 text-blue-400 hover:text-blue-300" data-testid="live-stream-open">
          {t("live.openYoutube")} <ExternalLink className="h-3 w-3" />
        </a>
      </div>
    </div>
  );
}
